import { useMemo } from 'react';
import { User } from 'models/User';
import { useAdminUsersQuery } from 'api';

export const useAdminUsersMapping = () => {
  const { data = [] } = useAdminUsersQuery();

  const adminUsersMapping = useMemo(() => {
    const mapping: Record<string, User> = {};
    data.forEach((i: User) => {
      mapping[i.id] = i;
    });
    return mapping;
  }, [data]);

  return {
    adminUsersMapping,
  };
};
